import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../firebase";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import classes from "./NoticeDetail.module.scss";
import timeIcon from "../../assets/img/clock.svg";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import DialogButton from "../../components/UIkit/DialogButton";
import Hero from "../../components/notice/Hero";

import {
  hideLoadingAction,
  showLoadingAction,
} from "../../reducks/loading/actions";
import { getUserInfo } from "../../reducks/users/selectors";
const NoticeDetail = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const userInfo = useSelector(getUserInfo);

  useEffect(() => {
    const fetchArticle = async () => {
      if (!slug) {
        dispatch(push("/notice/list"));
        return; // 早期リターン
      }

      if (!userInfo || !userInfo.email) {
        console.error("ユーザー情報が利用できません。");
        setError("ユーザー情報が利用できません。");
        return; // 早期リターン
      }

      try {
        dispatch(showLoadingAction("記事を読込み中..."));
        const docRef = doc(db, "articles", slug);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const articleData = docSnap.data();

          // targetUsersを初期化
          articleData.targetUsers = articleData.targetUsers || [];

          // userInfo.emailがtargetUsersに存在するか確認
          const existingUserIndex = articleData.targetUsers.findIndex(
            (user) => user.email === userInfo.email
          );

          let shouldUpdateFirestore = false;

          if (existingUserIndex !== -1) {
            // ユーザーが存在する場合
            if (articleData.targetUsers[existingUserIndex].isOpened === false) {
              articleData.targetUsers[existingUserIndex].isOpened = true;
              shouldUpdateFirestore = true;
            }
            // isOpenedがtrueの場合は何もしない
          } else {
            // ユーザーが存在しない場合、新しく追加
            articleData.targetUsers.push({
              email: userInfo.email,
              isOpened: true,
            });
            shouldUpdateFirestore = true;
          }

          if (shouldUpdateFirestore) {
            // Firestoreを更新
            await updateDoc(docRef, {
              targetUsers: articleData.targetUsers,
            });
          }

          // ステートを更新
          setArticle(articleData);
        } else {
          setError("記事が見つかりませんでした。");
        }
      } catch (err) {
        console.error("記事の取得中にエラーが発生しました:", err);
        setError("記事の取得中にエラーが発生しました。");
      } finally {
        dispatch(hideLoadingAction());
      }
    };

    fetchArticle();
  }, [slug, dispatch, userInfo]);

  return (
    <>
      {article && (
        <div className={classes.root}>
          <Hero title={article.title} />
          <div className={classes.main}>
            <div className={classes.title}>{article.title}</div>
            <div className={classes.attributes}>
              <p className={classes.category}>{article.category}</p>
              <p className={classes.createdAt}>
                <img src={timeIcon} />
                {article.createdDay}
              </p>
            </div>

            {/* 記事の内容を表示 */}
            <ReactQuill
              value={article.content}
              readOnly={true}
              theme="snow"
              modules={{ toolbar: false }}
            />

            {article.attachedFiles && article.attachedFiles.length > 0 && (
              <div style={{ margin: "60px 0" }}>
                <div className={classes.fileList}>
                  <p className={classNames(classes.category, classes.absolute)}>
                    資料
                  </p>
                  <div style={{ margin: "20px 0" }}></div>
                  <ul>
                    {article.attachedFiles.map((url, index) => (
                      <div className={classes.fileItem} key={index}>
                        <a href={url} target="_blank" rel="noopener noreferrer">
                          {article.attachedFilesName[index]}
                        </a>
                      </div>
                    ))}
                  </ul>
                </div>
              </div>
            )}
            <div className={classes.buttons}>
              <DialogButton
                label={"一覧に戻る"}
                onClick={() => dispatch(push("/notice/list"))}
                mode="no"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NoticeDetail;
